var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2316_4202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.7916 1.35278H6.89178C5.89769 1.35278 5.0918 2.15868 5.0918 3.15277V22.0526C5.0918 23.0467 5.89769 23.8526 6.89178 23.8526H25.7916C26.7857 23.8526 27.5916 23.0467 27.5916 22.0526V3.15277C27.5916 2.15868 26.7857 1.35278 25.7916 1.35278Z",
    fill: "#61B2E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2226 8.03188H21.3319V4.86788C19.9257 4.86788 14.3008 3.46164 14.3008 9.43812V11.5475H11.4883V15.0631H14.3008V24.302H17.8163V15.0631H20.9804L21.3319 11.5475H17.8163V9.43812C17.8163 8.03188 18.871 8.03188 19.2226 8.03188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8525 23.8526H26.14C26.9417 23.8526 27.5916 23.2027 27.5916 22.401V2.80438C27.5916 2.00267 26.9417 1.35278 26.14 1.35278H6.54339C5.74168 1.35278 5.0918 2.00267 5.0918 2.80438V22.401C5.0918 23.2027 5.74168 23.8526 6.54339 23.8526H17.1075",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9262 23.8519V14.9456H21.1325L21.4887 11.3831H17.9262V9.24554C17.9262 7.82053 18.9949 7.82053 19.3512 7.82053C19.7075 7.82053 21.4887 7.82053 21.4887 7.82053V4.61427C20.0489 4.46834 14.3637 3.18927 14.3637 9.24554V11.3831H11.5137V14.9456H14.3637V23.8519",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2316_4202",
    x: 0.591797,
    y: 0.852783,
    width: 31.5,
    height: 31.4998,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2316_4202"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2316_4202",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.523338724a7eee0793fd1af73b815e98.svg";
export { ForwardRef as ReactComponent };